import { Avatar } from "@/components/pieces/users/Avatar";
import { CertificationParticipantsQuery } from "@/graphql";

export function UserCell({
  user,
}: {
  user: NonNullable<
    CertificationParticipantsQuery["certification"]
  >["participants"]["data"][number]["user"];
}) {
  return (
    <div className="flex items-center gap-2">
      <Avatar user={user} size={20} />
      <div className="flex flex-col h-10 justify-center">
        <div className="text-base/snug">{user.name}</div>
        <div className="text-xs/snug text-gray-500">
          {user.groups?.map((group) => group?.name).join(", ")}
        </div>
      </div>
    </div>
  );
}
